import { initialObjTransactionsType } from 'components/tables/TransactionsTable/ViewsForm/data';
import { KeyTransactions } from 'components/tables/TransactionsTable/data';

const initialInternalRequiredKey = [
  KeyTransactions.TYPE,
  KeyTransactions.CATEGORY,
  KeyTransactions.DOCUMENT_NUMBER,
  KeyTransactions.DOCUMENT_ID,
  KeyTransactions.DOCUMENT_TYPE,
  KeyTransactions.CURRENCY,
  KeyTransactions.AMOUNT,
  KeyTransactions.RECIPIENT,
  KeyTransactions.DETAILS,
  KeyTransactions.COMMENT,
];

export const requiredInternalKeys = (transactionsFormData: initialObjTransactionsType) => {
  const initial = [...initialInternalRequiredKey, KeyTransactions.DOCUMENT_AO, KeyTransactions.CLAIMS];

  if (transactionsFormData[KeyTransactions.DOCUMENT_AO] && initial.indexOf(KeyTransactions.CLAIMS) !== -1) {
    initial.splice(initial.indexOf(KeyTransactions.CLAIMS), 1);
  }

  if (transactionsFormData[KeyTransactions.CLAIMS] && initial.indexOf(KeyTransactions.DOCUMENT_AO) !== -1) {
    initial.splice(initial.indexOf(KeyTransactions.DOCUMENT_AO), 1);
  }

  return initial;
};

export const errorsInternal = {
  [KeyTransactions.ROOT]: [
    { key: KeyTransactions.CATEGORY, parameters: { required: true } },
    { key: KeyTransactions.VALUE_DATE_TIME, parameters: { required: true } },
    { key: KeyTransactions.DOCUMENT_AO, parameters: { required: true } },
    { key: KeyTransactions.DOCUMENT_REQUEST, parameters: { required: true } },
    { key: KeyTransactions.TYPE, parameters: { required: true } },
    { key: KeyTransactions.CURRENCY, parameters: { required: true } },
    { key: KeyTransactions.AMOUNT, parameters: { required: true } },
    { key: KeyTransactions.RECIPIENT, parameters: { required: true } },
    { key: KeyTransactions.SENDER, parameters: { required: true } },
  ],
};

export type errorsOutgoingType = typeof errorsInternal;
